module.exports = __webpack_public_path__ + "img/up-yong-text-pc.dd3dca5b.png";